// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: 'Open Sans', Arial, sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 16px; /* Base font size */
}

.app {
  background: linear-gradient(to bottom, #ff7043, #ffffff);
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0;
  margin: 0;
  box-sizing: border-box; /* Ensure padding is included in width calculation */
}

.compact-layout {
  padding-top: 5px;
  gap: 0;
}

.title {
  font-size: 2.25rem; /* 36px based on 16px base */
  color: #ffffff;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
  animation: floatTitle 4s ease-in-out infinite;
  margin: 20px 0;
  font-weight: 700;
}

@keyframes floatTitle {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
}

.input-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  z-index: 2;
}

.name-input {
  padding: 0.8rem 1rem;
  border-radius: 6px;
  border: 1px solid #ddd;
  width: 260px;
  font-size: 1rem; /* 16px */
  text-align: center;
  font-family: 'Open Sans', Arial, sans-serif;
}

.name-instruction {
  color: #ffffff;
  font-size: 0.9rem;
  text-align: center;
  margin: -5px 0 5px;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
  background-color: rgba(255, 0, 0, 0.2);
  padding: 5px 10px;
  border-radius: 4px;
  max-width: 260px;
}

.join-button {
  background-color: #ff7043;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem; /* 16px */
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.join-button:hover {
  background-color: #f4511e;
}

.welcome-msg {
  font-size: 1.25rem;
  margin: 0 0 10px;
  padding: 0;
  color: #ffffff;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
  font-weight: 600;
}

.spinning-logo {
  width: 240px;
  height: auto;
  animation: spin 6s linear infinite;
  margin-bottom: 1rem;
}

.logo {
  width: 120px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
}

.top-logo {
  width: 100px;
  display: block;
  margin: 0 auto 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes bounceBBQ {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

/* Mobile Responsive Styles */
@media screen and (max-width: 768px) {
  .app {
    padding: 10px;
  }

  .title {
    font-size: 3rem;
    margin: 10px 0;
  }

  .input-section {
    margin: 20px 0;
    width: 100%;
    max-width: 300px;
  }

  .spinning-logo {
    width: 180px;
    margin-bottom: 20px;
  }
  
  .logo {
    width: 120px;
    margin-bottom: 5px;
  }
  
  .top-logo {
    width: 100px;
    margin-top: 0;
    margin-bottom: 5px;
  }

  .welcome-msg {
    font-size: 1.125rem;
    margin: 5px 0 10px;
  }
}

/* Confetti info styles */
.confetti-info {
  position: fixed;
  bottom: 10px;
  text-align: center;
  width: 100%;
  color: #777;
  font-size: 0.75rem;
}

.confetti-info code {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

/* About page styles */
.about-container {
  background: rgba(92, 54, 41, 0.95) !important; /* Dark brown background to match the box in the screenshot */
  border: 1px solid rgba(255, 119, 0, 0.3);
}

.about-content {
  color: #ffffff;
  text-shadow: 1px 1px 2px rgba(223, 24, 24, 0.2);
  padding: 15px;
  background-color: #5c3629 !important; /* Force brown background with !important */
  border-radius: 6px;
  margin-top: 10px;
}

.about-container h2 {
  color: #ff7700;
  text-align: center;
  margin-bottom: 15px;
}

.about-content h3 {
  color: #ff7700;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

.about-content p {
  margin-bottom: 15px;
  line-height: 1.5;
}

.about-content ul {
  margin: 15px 0;
  padding-left: 20px;
}

.about-content li {
  margin-bottom: 10px;
  line-height: 1.4;
}

.about-content strong {
  color: #ff9d4d;
}

.about-footer {
  margin-top: 25px;
  font-style: italic;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 15px;
}

.about-content-brown {
  color: #ffffff;
  text-shadow: 1px 1px 2px rgba(223, 24, 24, 0.2);
  padding: 15px;
  background-color: #5c3629 !important; /* Force brown background with !important */
  border-radius: 6px;
  margin-top: 10px;
}

.about-content-brown p {
  margin-bottom: 15px;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe,EAAE,mBAAmB;AACtC;;AAEA;EACE,wDAAwD;EACxD,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sBAAsB,EAAE,oDAAoD;AAC9E;;AAEA;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,kBAAkB,EAAE,4BAA4B;EAChD,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,6CAA6C;EAC7C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe,EAAE,SAAS;EAC1B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,6CAA6C,EAAE,6DAA6D;EAC5G,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,aAAa;EACb,oCAAoC,EAAE,2CAA2C;EACjF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,aAAa;EACb,oCAAoC,EAAE,2CAA2C;EACjF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  font-family: 'Open Sans', Arial, sans-serif;\n  overflow-y: auto;\n  overflow-x: hidden;\n  font-size: 16px; /* Base font size */\n}\n\n.app {\n  background: linear-gradient(to bottom, #ff7043, #ffffff);\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box; /* Ensure padding is included in width calculation */\n}\n\n.compact-layout {\n  padding-top: 5px;\n  gap: 0;\n}\n\n.title {\n  font-size: 2.25rem; /* 36px based on 16px base */\n  color: #ffffff;\n  text-align: center;\n  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);\n  animation: floatTitle 4s ease-in-out infinite;\n  margin: 20px 0;\n  font-weight: 700;\n}\n\n@keyframes floatTitle {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-5px); }\n}\n\n.input-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  z-index: 2;\n}\n\n.name-input {\n  padding: 0.8rem 1rem;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  width: 260px;\n  font-size: 1rem; /* 16px */\n  text-align: center;\n  font-family: 'Open Sans', Arial, sans-serif;\n}\n\n.name-instruction {\n  color: #ffffff;\n  font-size: 0.9rem;\n  text-align: center;\n  margin: -5px 0 5px;\n  font-weight: 600;\n  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);\n  background-color: rgba(255, 0, 0, 0.2);\n  padding: 5px 10px;\n  border-radius: 4px;\n  max-width: 260px;\n}\n\n.join-button {\n  background-color: #ff7043;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem; /* 16px */\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.join-button:hover {\n  background-color: #f4511e;\n}\n\n.welcome-msg {\n  font-size: 1.25rem;\n  margin: 0 0 10px;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);\n  font-weight: 600;\n}\n\n.spinning-logo {\n  width: 240px;\n  height: auto;\n  animation: spin 6s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.logo {\n  width: 120px;\n  height: auto;\n  display: block;\n  margin: 0 auto 10px;\n}\n\n.top-logo {\n  width: 100px;\n  display: block;\n  margin: 0 auto 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes bounceBBQ {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n/* Mobile Responsive Styles */\n@media screen and (max-width: 768px) {\n  .app {\n    padding: 10px;\n  }\n\n  .title {\n    font-size: 3rem;\n    margin: 10px 0;\n  }\n\n  .input-section {\n    margin: 20px 0;\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .spinning-logo {\n    width: 180px;\n    margin-bottom: 20px;\n  }\n  \n  .logo {\n    width: 120px;\n    margin-bottom: 5px;\n  }\n  \n  .top-logo {\n    width: 100px;\n    margin-top: 0;\n    margin-bottom: 5px;\n  }\n\n  .welcome-msg {\n    font-size: 1.125rem;\n    margin: 5px 0 10px;\n  }\n}\n\n/* Confetti info styles */\n.confetti-info {\n  position: fixed;\n  bottom: 10px;\n  text-align: center;\n  width: 100%;\n  color: #777;\n  font-size: 0.75rem;\n}\n\n.confetti-info code {\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-family: monospace;\n}\n\n/* About page styles */\n.about-container {\n  background: rgba(92, 54, 41, 0.95) !important; /* Dark brown background to match the box in the screenshot */\n  border: 1px solid rgba(255, 119, 0, 0.3);\n}\n\n.about-content {\n  color: #ffffff;\n  text-shadow: 1px 1px 2px rgba(223, 24, 24, 0.2);\n  padding: 15px;\n  background-color: #5c3629 !important; /* Force brown background with !important */\n  border-radius: 6px;\n  margin-top: 10px;\n}\n\n.about-container h2 {\n  color: #ff7700;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.about-content h3 {\n  color: #ff7700;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-size: 1.2rem;\n}\n\n.about-content p {\n  margin-bottom: 15px;\n  line-height: 1.5;\n}\n\n.about-content ul {\n  margin: 15px 0;\n  padding-left: 20px;\n}\n\n.about-content li {\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.about-content strong {\n  color: #ff9d4d;\n}\n\n.about-footer {\n  margin-top: 25px;\n  font-style: italic;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.9);\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  padding-top: 15px;\n}\n\n.about-content-brown {\n  color: #ffffff;\n  text-shadow: 1px 1px 2px rgba(223, 24, 24, 0.2);\n  padding: 15px;\n  background-color: #5c3629 !important; /* Force brown background with !important */\n  border-radius: 6px;\n  margin-top: 10px;\n}\n\n.about-content-brown p {\n  margin-bottom: 15px;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
